function extractDigits(value: string) {
  return value.replace(/\D/g, '');
}

export function formatPhone(value: string) {
  if (!value) return value;

  const PHONE_LENGTH = 10;
  const digits = extractDigits(value);

  if (digits.length > PHONE_LENGTH) {
    return value;
  }

  const first = digits.slice(0, 3);
  const second = digits.slice(3, 6);
  const third = digits.slice(6, 10);

  return `${first}${second ? '-' : ''}${second}${third ? '-' : ''}${third}`;
}
